import * as Yup from "yup";

// Define a reusable schema for the event objects
// const driverEventSchema = Yup.object().shape({
//     isActive: Yup.boolean().required(),
//     mins: Yup.number().when("isActive", {
//       is: (val) => val === true,
//       then: () =>
//         Yup.number()
//           .required("Mins are required when active")
//           .min(0, "minutes cannot be negative")
//           .test(
//             "not-negative-zero",
//             "Negative zero (-0) is not allowed",
//             (value) => !Object.is(value, -0), // Explicit check for -0
//           ),
//       otherwise: (schema) =>
//         schema
//           .nullable()
//           .transform((value, originalValue) =>
//             originalValue === "" ? null : value,
//           ),
//     }),
//     latitude: Yup.string().when("isActive", {
//       is: (val) => val === true,
//       then: () =>
//         Yup.string()
//           .required("Latitude is required when active")
//           .test(
//             "is-valid-lat",
//             "Invalid latitude (must be between -90 and 90)",
//             (value) => {
//               const num = parseFloat(value);
//               return !isNaN(num) && num >= -90 && num <= 90;
//             },
//           ),
//     }),
//     longitude: Yup.string().when("isActive", {
//       is: (val) => val === true,
//       then: () =>
//         Yup.string()
//           .required("Latitude is required when active")
//           .test(
//             "is-valid-lng",
//             "Invalid longitude (must be between -180 and 180)",
//             (value) => {
//               const num = parseFloat(value);
//               return !isNaN(num) && num >= -180 && num <= 180;
//             },
//           ),
//     }),
//     extraCoordinates: Yup.array().of(
//       Yup.object().shape({
//         longitude: Yup.string()
//           .required("Longitude is required") 
//           .test("is-valid-lng", "Invalid longitude", (value) => {
//             if (!value) return false; 
//             const num = parseFloat(value);
//             return !isNaN(num) && num >= -180 && num <= 180;
//           }),
//         latitude: Yup.string()
//           .required("Latitude is required") 
//           .test("is-valid-lat", "Invalid latitude", (value) => {
//             if (!value) return false;
//             const num = parseFloat(value);
//             return !isNaN(num) && num >= -90 && num <= 90;
//           }),
//       }),
//     ),
//   });

const coordinateSchema = Yup.object().shape({
  longitude: Yup.string()
    .required("Longitude is required")
    .test("is-valid-lng", "Invalid longitude", (value) => {
      const num = parseFloat(value);

      return !isNaN(num) && num >= -180 && num <= 180;
    }),

  latitude: Yup.string()
    .required("Latitude is required")
    .test("is-valid-lat", "Invalid latitude", (value) => {
      const num = parseFloat(value);

      return !isNaN(num) && num >= -90 && num <= 90;
    }),
});

const driverEventSchema = Yup.object().shape({
  isActive: Yup.boolean().required(),

  mins: Yup.number().when("isActive", {
    is: true,
    then: () =>
      Yup.number()
        .required("Mins are required when active")
        .min(0, "minutes cannot be negative")
        .test(
          "not-negative-zero",
          "Negative zero (-0) is not allowed",
          (value) => !Object.is(value, -0),
        ),

    otherwise: (schema) =>
      schema.nullable().transform((value, originalValue) =>
        originalValue === "" ? null : value,
      ),
  }),

  latitude: Yup.string().when("isActive", {
    is: true,
    then: () =>
      Yup.string()
        .required("Latitude is required when active")
        .test(
          "is-valid-lat",
          "Invalid latitude (must be between -90 and 90)",
          (value) => {
            const num = parseFloat(value);

            return !isNaN(num) && num >= -90 && num <= 90;
          },
        ),
  }),

  longitude: Yup.string().when("isActive", {
    is: true,
    then: () =>
      Yup.string()
        .required("Longitude is required when active")
        .test(
          "is-valid-lng",
          "Invalid longitude (must be between -180 and 180)",
          (value) => {
            const num = parseFloat(value);

            return !isNaN(num) && num >= -180 && num <= 180;
          },
        ),
  }),

  // extraCoordinates: Yup.array()
  //   .nullable()
  //   .of(
  //     Yup.lazy((value) => {
  //       // If row is completely empty -> skip validation
  //       if (
  //         !value ||
  //         (!value.latitude?.toString()?.trim() &&
  //           !value.longitude?.toString()?.trim())
  //       ) {
  //         return Yup.object().shape({
  //           latitude: Yup.string().nullable(),
  //           longitude: Yup.string().nullable(),
  //         });
  //       }

  //       // If row exists / user added values -> validate strictly
  //       return coordinateSchema;
  //     }),
  //   ),
  extraCoordinates: Yup.array().of(
    Yup.object().shape({
      longitude: Yup.string()
        .required("Longitude is required")
        .test("is-valid-lng", "Invalid longitude", (value) => {
          const num = parseFloat(value);
  
          return !isNaN(num) && num >= -180 && num <= 180;
        }),
  
      latitude: Yup.string()
        .required("Latitude is required")
        .test("is-valid-lat", "Invalid latitude", (value) => {
          const num = parseFloat(value);
  
          return !isNaN(num) && num >= -90 && num <= 90;
        }),
    }),
  ),
});
  
  // Main validation schema
export const validationSchema = Yup.object().shape({
    driverDepartedToAirportEvent: driverEventSchema,
    driverArrivedToAirportEvent: driverEventSchema,
    driverNoShowToAirportEvent: driverEventSchema,
    autoDriverAssignment: Yup.object().shape({
      isActive: Yup.boolean().required(),
      hours: Yup.number().when("isActive", {
        is: true,
        then: (schema) =>
          schema
            .required("Hours are required when `Status` is active")
            .min(1, "Hours must be greater than 0 (cannot be negative or zero).")
            .test(
              "not-negative-zero",
              "Negative zero (-0) is not allowed",
              (value) => !Object.is(value, -0), // Explicit check for -0
            ),
        otherwise: (schema) =>
          schema
            .nullable()
            .transform((value, originalValue) =>
              originalValue === "" ? null : value,
            ),
      }),
    }),
  });